import { render, staticRenderFns } from "./PainelNotificacao.vue?vue&type=template&id=1d6ff20f&"
import script from "./PainelNotificacao.vue?vue&type=script&lang=js&"
export * from "./PainelNotificacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports